import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  applicationsCountsKey,
  employerApplicationsKey,
  bulkActionRoute,
  errorMessage,
  enterpriseApplicationsKey,
  interviewCountsKey,
  applicationHistoryKey,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { applicantDetailsKey } from '@features/applicant';
import { jobPostingsKey } from '@features/jobPostings';

type UseBulkActionProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useBulkAction = ({ setErrorText }: UseBulkActionProps) => {
  const client = useQueryClient();

  const {
    data: bulkActionData,
    mutate: createBulkAction,
    isLoading: isCreateBulkActionLoading,
    isSuccess: isCreateBulkActionSuccess,
    reset: resetCreateBulkAction,
  } = useMutation({
    mutationFn: (variables: {
      action: string;
      ids: string;
      message?: string;
    }) =>
      axiosInstance.post(bulkActionRoute, variables).then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries(enterpriseApplicationsKey);
        client.invalidateQueries(applicationsCountsKey);
        client.invalidateQueries(applicantDetailsKey);
        client.invalidateQueries(employerApplicationsKey);
        client.invalidateQueries(interviewCountsKey);
        client.invalidateQueries(applicationHistoryKey);
        client.invalidateQueries(jobPostingsKey);

        setErrorText('');
      } else {
        setErrorText(data?.message || errorMessage);
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });
  return {
    bulkActionData,
    createBulkAction,
    isCreateBulkActionLoading,
    isCreateBulkActionSuccess,
    resetCreateBulkAction,
  };
};
